import { useEffect } from "react";

import { triggerLogin } from "authentication/actions";
import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useGo } from "common/utilities/useGo";
import { getIsAuthenticated } from "domains/authentication/selectors";

type ForbiddenProps = { onDismissRoute?: string };

export const Forbidden = ({ onDismissRoute = "/" }: ForbiddenProps) => {
  const dispatch = useDispatch();
  const go = useGo();
  const isAuthenticated = useSelector(getIsAuthenticated);

  useEffect(() => {
    if (isAuthenticated) go("/", { replace: true });
    else dispatch(triggerLogin({ onDismissRoute }));
  }, [dispatch, go, isAuthenticated, onDismissRoute]);

  return null;
};
